import Cookies from 'js-cookie'

const state = {
  sidebar: {
    opened: Cookies.get('sidebarStatus') ? !!+Cookies.get('sidebarStatus') : true,
    withoutAnimation: false
  },
  showPendingPopup: false,
  language: Cookies.get('language') || 'en',
  device: 'desktop',
  showDownloadList: false,
  isPii: process.env.VUE_APP_PLATFORM === 'paycools',
  isEz: process.env.VUE_APP_PLATFORM === 'ezpay',
  isID: process.env.VUE_APP_PLATFORM === 'id',
  isMX: process.env.VUE_APP_PLATFORM === 'mx',
  isAruxpay: process.env.VUE_APP_PLATFORM === 'aruxpay',
  platform: process.env.VUE_APP_PLATFORM
}

const mutations = {
  TOGGLE_SIDEBAR: state => {
    state.sidebar.opened = !state.sidebar.opened
    state.sidebar.withoutAnimation = false
    if (state.sidebar.opened) {
      Cookies.set('sidebarStatus', 1)
    } else {
      Cookies.set('sidebarStatus', 0)
    }
  },
  CLOSE_SIDEBAR: (state, withoutAnimation) => {
    Cookies.set('sidebarStatus', 0)
    state.sidebar.opened = false
    state.sidebar.withoutAnimation = withoutAnimation
  },
  SET_LANGUAGE: (state, language) => {
    state.language = language
    Cookies.set('language', language)
  },
  TOGGLE_DEVICE: (state, device) => {
    state.device = device
  },
  SET_SHOW_DOWNLOAD_LIST: (state, showDownloadList) => {
    state.showDownloadList = showDownloadList
  },
  SET_PENDING_POPUP: (state, flag) => {
    state.showPendingPopup = flag
  }
}

const actions = {
  toggleSideBar({ commit }) {
    commit('TOGGLE_SIDEBAR')
  },
  closeSideBar({ commit }, { withoutAnimation }) {
    commit('CLOSE_SIDEBAR', withoutAnimation)
  },
  setLanguage({ commit }, language) {
    commit('SET_LANGUAGE', language)
  },
  toggleDevice({ commit }, device) {
    commit('TOGGLE_DEVICE', device)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
